/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Scene7Service, TaggingService } from '@shared/utils/services';

@Component({
    selector: 'shared-media-component-video',
    styleUrls: ['./media-video.component.scss'],
    templateUrl: './media-video.component.html',
    standalone: false
})
export class MediaVideoComponent implements OnInit {
	@Input() altText: string;
	@Input() badge: any = null;
	@Input() image: string;
	@Input() mobileImg: string;
	@Input() gif: string;
	@Input() gifMobile: string;
	@Input() itemTitle: string;
	@Input() animation: string;
	@Input() youtubeId: string;
	@Input() imagePreset: any = null;
	@Input() willLazyLoad = true;

	urlSafe: SafeResourceUrl;
	mediaTitleText: string;

	constructor(
		private taggingService: TaggingService,
		private scene7Service: Scene7Service,
		private sanitizer: DomSanitizer
	) { }

	ngOnInit() {
		this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
			`https://www.youtube.com/embed/${this.youtubeId}`
		);
		this.mediaTitleText = this.taggingService.altTag(this.altText, this.itemTitle);
	}

	scene7service(imageName, ImagePreset, isContent) {
		return this.scene7Service.scene7Url(imageName, ImagePreset, isContent);
	}
}
